export const WORKSPACE_IDENTITIES = {
  superadmin: {
    key: 'level-one', level: '第一级', mark: 'SA', eyebrow: 'PLATFORM SUPERADMIN',
    name: '平台超级管理员', workspace: '平台总管理后台', headline: '管理所有企业与企业总部账号',
    summary: '平台 Superadmin 只负责企业层级管理：查看有多少企业，并为企业开设总部管理账号。',
    cardTitle: '登录平台总管理后台', cardSummary: '仅限平台 Superadmin 登录；不会进入任何企业的日常项目。',
    button: '登录第一级平台后台', emailPlaceholder: '请输入平台 Superadmin 邮箱',
    promises: ['管理平台内全部企业', '开设 AI 企业总部管理账号', '查看每个企业的项目经理与项目数量'],
  },
  enterprise: {
    key: 'level-two', level: '第二级', showHierarchy: false, mark: 'HQ', eyebrow: 'AI ENTERPRISE HEADQUARTERS',
    name: 'AI 企业总部', workspace: 'AI 企业总部管理后台', headline: '管理本企业的 AI 营销项目经理',
    summary: 'AI Marketing PaaS Superadmin 是企业总部账号，只管理本企业的项目经理及其独立项目概况。',
    cardTitle: '登录企业总部管理后台', cardSummary: '仅限企业总部管理员登录；只能看到所属企业的数据。',
    button: '登录企业总部管理后台', emailPlaceholder: '请输入企业总部账号邮箱',
    promises: ['管理本企业多个 AI 营销项目经理', '查看每位经理的独立项目与用户 App', '企业之间资料与权限完全隔离'],
  },
  projectManager: {
    key: 'level-three', level: '第三级', showHierarchy: false, mark: 'PM', eyebrow: 'AI MARKETING PROJECT MANAGER',
    name: 'AI 营销项目经理', workspace: 'AI 营销项目经理工作台', headline: '完成企业营销与用户 App 任务协作',
    summary: 'AI 营销项目经理首次登录会建立自己的独立企业项目，并管理人设、素材与每日任务。',
    cardTitle: '登录 AI 营销项目经理工作台', cardSummary: '只进入自己账号的企业项目，不会看到其他企业或其他项目经理的资料。',
    button: '登录 AI 营销项目经理工作台', emailPlaceholder: '请输入项目经理账号邮箱',
    promises: ['首次登录建立自己的企业项目', '管理人设、真实素材与每日任务', '与用户 App 的接收、生成和完成记录同步'],
  },
}

export function workspaceIdentityForTarget(target = '') {
  const path = String(target || '')
  if (path.startsWith('/superadmin')) return WORKSPACE_IDENTITIES.superadmin
  if (path.startsWith('/enterprise-admin')) return WORKSPACE_IDENTITIES.enterprise
  return WORKSPACE_IDENTITIES.projectManager
}

export function workspaceIdentityForRole(role = '') {
  if (role === 'superadmin') return WORKSPACE_IDENTITIES.superadmin
  if (role === 'enterprise_admin') return WORKSPACE_IDENTITIES.enterprise
  return WORKSPACE_IDENTITIES.projectManager
}
